import React, { useState, useEffect, useCallback } from 'react';
import { NavLink, useParams} from 'react-router-dom';
import ConstruirPdfFormatoRetorno from './ConstruirPDFFormatoRetornos';
import { ConsultarDatosRetornoFormatoCompleto } from './../../Auth/ConsultasApi';
import { useAuth } from '../../Auth/AuthContext';
import SweetAlert2 from 'react-sweetalert2';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import CargandoSpinner from '../Utils/CargandoSpinner';

export default function FormatoCompleto(){
    const { token, rol } = useAuth();
    const [swalProps, setSwalProps] = useState({});
    const { idRetorno } = useParams();
    const { idCabezaFamilia } = useParams();
    const [pdfFile, setPdfFile] = useState(null);
    const [numPages, setNumPages] = useState(null);

    const handleGeneratePdf = useCallback((data) => { 
        const url = ConstruirPdfFormatoRetorno(data); 
        setPdfFile(url); 
    }, []);
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    useEffect(() => {
        const fetchData = async (idRetorno, rol, idCabezaFamilia) => {
            const obj = {idRetorno: idRetorno, idCabezaFamilia: idCabezaFamilia, usrRolid: rol }
            setCargando(true);
            await ConsultarDatosRetornoFormatoCompleto({obj, token})
            .then((response) => {
                const result = response.data;
                handleGeneratePdf(result);
            })
            .catch((error) => {
                Mensaje('Error', 'No se pudo generar el PDF.');
                console.error('Error fetching data:', error);
            })
            .finally(() => {
                setCargando(false);
            });
        };

        fetchData(idRetorno, rol, idCabezaFamilia);
    }, [idRetorno, rol, idCabezaFamilia, token]);
    const [Cargando, setCargando] = useState(false);
    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
      };
   
    return (
        <div className="content-wrapper">
            <SeccionPageHeader title="Formato retornos" idCabezaFamilia={idCabezaFamilia} url={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} nombreurl="Grupo familiar" nombreform="Formato retornos" />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div>
                    {pdfFile && ( 
                        <iframe 
                            src={pdfFile} 
                            width="100%" 
                            height="800" 
                            title="PDF retorno completo" 
                            style={{ border: 'none' }} 
                            allow="autoplay; encrypted-media" 
                            loading="lazy"
                        /> 
                    )}
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
            didClose={() => {
                setSwalProps({})
            }}/>
        </div>
    );
}